import * as React from 'react'
import { List, ListItem, Typography } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import { muiColors, muiTypography } from '@zuto/theme/src/mui/DefaultTheme'

interface CheckedListProps {
  list: string[]
  darkerText?: boolean
  textVariant?: 'rowHeading' | 'labelLarge'
  fontSize?: number
  icon?: React.ReactNode
  icons?: React.ReactNode[]
  iconForIndex?: (i: number) => React.ReactNode
  compress?: boolean
  textCentered?: boolean
}

const styles = (darkerText: boolean, compress: boolean, textCentered?: boolean) => ({
  li: {
    ...muiTypography.body.text.normal,
    margin: 0,
    paddingLeft: '5px',
    paddingBottom: compress ? '0px' : '5px',
    color: darkerText ? muiColors.primary.blackAlt : muiColors.primary.blackAltOpacity80,
    ':last-child': { paddingBottom: 0 },
    ...(textCentered ? { justifyContent: 'center', alignItems: 'center' } : {})
  },
  svg: { paddingBottom: '2px', paddingRight: darkerText ? 5 : 'initial' }
})

const CheckedList: React.FC<CheckedListProps> = ({
  list,
  darkerText = false,
  textVariant = 'rowHeading',
  fontSize = 14,
  icon,
  icons,
  iconForIndex,
  compress = false,
  textCentered = false
}) => {
  const defaultIcon = (
    <CheckIcon color="success" fontSize="small" style={{ paddingRight: 5 }} />
  )

  const getIcon = (i: number): React.ReactNode =>
    iconForIndex?.(i) ?? icons?.[i] ?? icon ?? defaultIcon

  return (
    <List
      data-testid="checked-list"
      sx={{ maxWidth: `100% !important`, ...styles(darkerText, compress, textCentered) }}
    >
      {list.map((text, i) => (
        <ListItem key={`${text}-${i}`}>
          {getIcon(i)}
          {darkerText ? (
            <Typography variant={textVariant} fontSize={fontSize} sx={{ paddingTop: icons ? '5px' : 0 }}>
              {text}
            </Typography>
          ) : (
            text
          )}
        </ListItem>
      ))}
    </List>
  )
}

export default CheckedList
